import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleDownMedium: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-down-medium, dropdown, caret"><path d="M16.1764 9C17.2385 9 17.8166 10.2405 17.1335 11.0537L12.9567 16.0264C12.4571 16.6209 11.5421 16.621 11.0426 16.0264L6.86589 11.0537C6.18308 10.2406 6.76114 9.00028 7.82292 9H16.1764Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronTriangleDownMedium;
